<template>
    <div class="bg-white w-full h-20 flex lg:hidden items-center pl-4">
        <Link :href="route($page.props.locale + '.dashboard')">
          <ApplicationLogo width="145" />
        </Link>
    </div>
</template>

<script>
import ApplicationLogo from "@/Components/ApplicationLogo";
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {ApplicationLogo, Link}
}
</script>
